import { isNil } from 'lodash';

import type { StpNotification } from '~/components/ClaimPage/CliveApp/CliveNotifications/types';
import type { ClaimConductorAsksResponse } from '~/server_shared/openapi/data-contracts';

import { getNotifiedAskId } from '../utils';

import { useRefetchForNewEntries } from './useRefetchForNewEntries';

const isAskEntry = (notification: StpNotification): boolean => !isNil(getNotifiedAskId(notification));

/**
 * Refetches the claim's asks when an entry about an ask lands, by `useRefetchForNewEntries`' rules.
 *
 * Every such entry asks, and not only one naming an ask the tab has not read: Clive closing an ask
 * publishes a new entry about an ask the tab already holds, and only a fresh read says it closed.
 */
export const useRefetchForNewAskEntries = (
  notifications: StpNotification[],
  /** The asks' first read has settled, landed or failed, and the stream has its first snapshot. */
  isReady: boolean,
  /** `reloadData`, typed to the response for the reason `useRefetchForNewEntries` gives. */
  refetchAsks: () => Promise<ClaimConductorAsksResponse | undefined>
): void => useRefetchForNewEntries(notifications, isAskEntry, isReady, refetchAsks);
